var t = /* @__PURE__ */ ((r) => (r.LIGHT = "light", r.DARK = "dark", r.SYSTEM = "system", r))(t || {});
export {
  t as ThemeMode
};
